// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-file-inputs {
    position: relative;
    
    border: 1px dashed #9ca2ad;
    border-radius: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    margin-top: 25px;
}

.drop-file-inputs input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    /* top: 50px; */
   
 
}

.drop-file-inputs:hover,
.drop-file-inputs.dragover {
    opacity: 0.6;
}

.drop-file-inputs__label {
    text-align: center;
    color:#ccc;
    font-weight: 600;
    padding: 10px;
}

.drop-file-inputs__label img {
    width: 100px;
}

.drop-file-preview {
    /* margin-top: 30px; */
}

.drop-file-preview p {
    font-weight: 500;
}

.drop-file-preview__title {
    margin-bottom: 20px;
}

.drop-file-preview__item {
    position: relative;
    display: flex;
    margin-bottom: 10px;
    background-color: #f5f8ff;
    padding: 15px;
    border-radius: 20px;
}

.drop-file-preview__item img {
    width: 50px;
    margin-right: 20px;
}

.drop-file-preview__item__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.drop-file-preview__item__del {
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.drop-file-preview__item:hover .drop-file-preview__item__del {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/kyc/components/aadhaar-file-input.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,0BAA0B;IAC1B,mBAAmB;;IAEnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,uDAAuD;IACvD,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;;;AAGnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,iDAAiD;IACjD,eAAe;IACf,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd","sourcesContent":[".drop-file-inputs {\n    position: relative;\n    \n    border: 1px dashed #9ca2ad;\n    border-radius: 20px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background-color: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n    margin-top: 25px;\n}\n\n.drop-file-inputs input {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    /* top: 50px; */\n   \n \n}\n\n.drop-file-inputs:hover,\n.drop-file-inputs.dragover {\n    opacity: 0.6;\n}\n\n.drop-file-inputs__label {\n    text-align: center;\n    color:#ccc;\n    font-weight: 600;\n    padding: 10px;\n}\n\n.drop-file-inputs__label img {\n    width: 100px;\n}\n\n.drop-file-preview {\n    /* margin-top: 30px; */\n}\n\n.drop-file-preview p {\n    font-weight: 500;\n}\n\n.drop-file-preview__title {\n    margin-bottom: 20px;\n}\n\n.drop-file-preview__item {\n    position: relative;\n    display: flex;\n    margin-bottom: 10px;\n    background-color: #f5f8ff;\n    padding: 15px;\n    border-radius: 20px;\n}\n\n.drop-file-preview__item img {\n    width: 50px;\n    margin-right: 20px;\n}\n\n.drop-file-preview__item__info {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.drop-file-preview__item__del {\n    background-color: #fff;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n    cursor: pointer;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.drop-file-preview__item:hover .drop-file-preview__item__del {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
